import { MenuItem, SideDrawer } from '@stern-ui/ui';
import clsx from 'clsx';
import { Close, Menu } from 'mdi-material-ui';
import { useDispatch } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';

import { resetState } from '@/components';
import { trackEvent } from '@/lib/analytics';

import { sideNavigationMenuConfig } from './menuConfig';

export type SideNavigationMenuProps = {
	close: () => void;
	isOpen: boolean;
	open: () => void;
};

export const SideNavigationMenu = (props: SideNavigationMenuProps) => {
	const { close, isOpen, open } = props;
	const dispatch = useDispatch();
	const location = useLocation();

	const handleClick = (label: string) => {
		dispatch(resetState());
		trackEvent(`${label} menu item clicked`);
	};

	const isParentActive = (link: string) => {
		const trimmedLink = link.substring(1);
		const rootUrl = location.pathname.split('/');
		if (rootUrl[1].toLowerCase() === trimmedLink.toLowerCase()) return true;
		return false;
	};

	const handleButtonClick = () => {
		if (isOpen) {
			close();
			trackEvent('Sidebar menu closed');
		} else {
			open();
			trackEvent('Sidebar menu expanded');
		}
	};

	const renderMenuItems = () => {
		return sideNavigationMenuConfig.map((item, index) => {
			const { children, icon, label, link, testId } = item;
			return (
				<li className='list-none' key={index}>
					<NavLink
						children={({ isActive }) => (
							<MenuItem
								label={label}
								icon={icon}
								isActive={isActive}
								isExpanded={isOpen}
								onClick={() => handleClick(label)}
								testId={testId}
							/>
						)}
						end
						to={link}
					></NavLink>
					{children && children.length > 0 && (
						<ul
							className={clsx(
								isParentActive(link) ? '' : 'hidden',
								isOpen ? 'mx-4' : ''
							)}
						>
							{children.map((child, index) => (
								<li className='list-none' key={'child' + index}>
									<NavLink
										children={({ isActive }) => (
											<MenuItem
												label={child.label}
												icon={child.icon}
												isActive={isActive}
												isExpanded={isOpen}
												onClick={() => handleClick(child.label)}
												testId={child.testId}
											/>
										)}
										to={child.link}
									></NavLink>
								</li>
							))}
						</ul>
					)}
				</li>
			);
		});
	};

	return (
		<div className='fixed top-0 left-0'>
			<SideDrawer
				isExpanded={isOpen}
				containerClass={clsx(
					'bg-primaryBackground h-screen min-h-screen pt-5 overflow-x-hidden z-30',
					isOpen ? 'w-[280px]' : 'w-[64px]'
				)}
				buttonClass='top-[1.25rem] right-[0.75rem]'
				handleClick={handleButtonClick}
				name='Main menu'
				openIcon={<Menu className='text-secondaryTextDark' />}
				closeIcon={<Close className='text-secondaryTextDark' />}
			>
				<nav className='mx-2 mt-16'>
					<ul>{renderMenuItems()}</ul>
				</nav>
			</SideDrawer>
		</div>
	);
};
